//@ts-check
import bootstrap from "./bootstrap";
import log from "./Log";
import sessionAlert from "./sessionAlert";

window.onerror = (message, url, line) => {
    const url_string = url || "";
    const line_number = line || -1;
    log.sendMessage(message, url_string, line_number);
    return false;
};

bootstrap();

sessionAlert();
